import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
} from "reactstrap";


const API_BASE = process.env.REACT_APP_API_URL || "/api";
const MEDIA_BASE = `${API_BASE}/media`;

const CustomAudioPlayer = ({ species, mode = "latest", audioSrc, imageSrc, onReady }) => {
  const containerRef = useRef(null);
  const [srcs, setSrcs] = useState({
    audio: null,
    image: null,
    metadata: null,
  });

  useEffect(() => {
    if (srcs.audio && srcs.image && containerRef.current) {
      containerRef.current.setAttribute("data-audio-src", srcs.audio);
      containerRef.current.setAttribute("data-image-src", srcs.image);

      if (typeof onReady === "function") {
        onReady();
      }
    }
  }, [srcs]);


  useEffect(() => {
    const fetchAndSet = async () => {
      try {
        if (!audioSrc) {
          const params = new URLSearchParams();
          params.set("mode", mode);
          if (species) params.set("species", species);

          const url = `${API_BASE}/detections/getaudiofile?${params.toString()}`;
          console.log("Fetching audio file from:", url);
          const res = await fetch(url);
          const data = await res.json();

          if (data.filename) {
            const encoded = encodeURIComponent(data.filename);
            const audio = `${MEDIA_BASE}/mp3/${encoded}`;
            const image = `${MEDIA_BASE}/png/${encoded}.png`;

            setSrcs({
              audio,
              image,
              metadata: {
                date: data.date,
                time: data.time,
                confidence: data.confidence,
                common: data.common,
                scientific: data.scientific,
              },
            });
          }
        } else {
          setSrcs({ audio: audioSrc, image: imageSrc });
        }
      } catch (err) {
        console.error("Failed to fetch audio file:", err);
      }
    };

    fetchAndSet();
  }, [species, mode, audioSrc, imageSrc]);

  return (
    <Card className="shadow my-4">
      <CardHeader>
        <CardTitle tag="h5" className="mb-0">
          {srcs.metadata ? (
            <>
              <strong>
                {srcs.metadata.date} at {srcs.metadata.time} &middot; Confidence: {(srcs.metadata.confidence * 100).toFixed(1)}%
              </strong>{" "}
              <br />
              <small className="text-muted">
                {srcs.metadata.common} <em>({srcs.metadata.scientific})</em>
              </small>
            </>
          ) : (
            <span className="text-muted">Loading metadata...</span>
          )}
        </CardTitle>
      </CardHeader>
      <CardBody className="text-center">
        <div
          ref={containerRef}
          className="custom-audio-player"
          data-audio-src={srcs.audio}
          data-image-src={srcs.image}
        >
          {!srcs.audio && (
            <p style={{ color: "gray" }}>Loading audio...</p>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

// ✅ Add static helper to init all players manually
CustomAudioPlayer.initAllPlayers = () => {
  setTimeout(() => {
    if (window.initCustomAudioPlayers) {
      console.log("✅ CustomAudioPlayer.initAllPlayers(): initializing...");
      window.initCustomAudioPlayers();
    } else {
      console.warn("⚠️ window.initCustomAudioPlayers not defined");
    }
  }, 100); // Small delay to ensure DOM is hydrated
};

export default CustomAudioPlayer;
